<script>
import DataProvider from './DataProvider.vue';
import MemberRepository from '../../js/repository/MemberRepository';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        date: {
            type: String,
            required: true,
        },
        limit: {
            type: Number,
            required: true,
        },
        offset: {
            type: Number,
            required: true,
        },
        callback: {
            type: Function,
            required: false,
            default: () => {},
        },
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: MemberRepository.findStocktakingUnconsideredMembers,
                params: [this.clubId, this.date, this.limit, this.offset],
                callback: this.callback,
            },
            scopedSlots: this.$scopedSlots,
        });
    },
};
</script>
